module.exports = __webpack_public_path__ + "img/canvasMenuEdit.92789488.svg";